import { useRef } from 'react'
import Header from '@components/Header/Header'
import Footer from '@components/Footer/Footer'
import Herobanner from './sections/Herobanner/Herobanner'
import Features from './sections/Features/Features'
import Ecosystem from './sections/Ecosystem/Ecosystem'
import Partners from './sections/Partners/Partners'
import Ecomerce from './sections/Ecomerce/Ecomerce'
import Pricing from './sections/Pricing/Pricing'

import './Home.css'

export default function Home() {
  const scrollable = useRef<HTMLDivElement>(null)
  return (
    <div id="home" className="page" ref={scrollable}>
      <Header />
      <Herobanner />
      <Features scrollable={scrollable} />
      <Ecosystem />
      <Pricing scrollable={scrollable} />
      <Partners />
      <Ecomerce />
      <Footer darkTheme={false} />
    </div>
  )
}
